import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
export default new Vuex.Store({
  state: {
    scroll: 0
  },
  mutations: {
    setScroll (state, payload) {
      state.scroll = payload
    }
  }
})



// WEBPACK FOOTER //
// ./src/vuex/index.js